export default "assets/images/icons/map_marker-08b0f6aa.svg";